export const financieraRoutes = [
  {
    path: '/financiera',
    name: 'Financiera',
    component: () =>
      import(
        /* webpackChunkName: "financiera" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiCurrencyUsd',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Financiera',
      requiresSession: true,
      perfiles: ['FINANCIERA'],
      permiso: []
    },
    children: [
      {
        path: '/financiera/cuentas-cobro',
        name: 'CuentasCobro',
        component: () =>
          import(
            /* webpackChunkName: "financiera" */ '@/modules/Financiera/views/CuentasCobros/CuentasCobrosIndex.vue'
          ),
        icon: 'mdiInvoice',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Cuentas de cobro',
          requiresSession: true,
          permiso: [],
          perfiles: ['FINANCIERA'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/financiera/cuentas-cobro/:id',
        name: 'CuentaCobroView',
        component: () =>
          import(
            /* webpackChunkName: "financiera" */ '@/modules/Financiera/views/CuentasCobros/CuentasCobrosView.vue'
          ),
        icon: 'ClockIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Cuenta de cobro',
          requiresSession: true,
          perfiles: ['FINANCIERA'],
          permiso: []
        },
        children: []
      },
      {
        path: '/financiera/numeracion-dian',
        name: 'NumeracionDian',
        component: () =>
          import(
            /* webpackChunkName: "financiera" */ '@/modules/Financiera/views/NumeracionDian/NumeracionDianIndex.vue'
          ),
        icon: 'WalletIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Numeración Dian',
          requiresSession: true,
          perfiles: ['FINANCIERA'],
          permiso: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/financiera/auditoria',
        name: 'Auditoria',
        component: () =>
          import(
            /* webpackChunkName: "financiera" */ '@/modules/Financiera/views/Auditoria/AuditoriaIndex.vue'
          ),
        icon: 'ClipboardDocumentCheckIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Auditoría',
          requiresSession: true,
          perfiles: ['FINANCIERA'],
          permiso: [],
          showBackButton: false
        },
        children: []
      }
    ]
  }
]
